export const BRAND = {
  color: {
    orange: '#FF5500',
    ink: '#1A1A1A',
    white: '#FFFFFF',
    smoke: '#F5F5F3',
    line: '#D8D5D1',
    graphite: '#2A2927',
    success: '#167A45',
    warning: '#B65C00',
    danger: '#C92A2A',
  },
  font: {
    display: 'Clarity City',
    body: 'Clarity City',
    mono: 'AtkinsonHyperlegibleMono',
  },
} as const;
